<template v-if="storeStores.store != undefined">
    <div class="box_content p-4">
        <div>
            <BaseInput
                class="col-12 mb-3"
                label="Host SMTP"
                type="text"
                v-model="storeStores.store.meta.smtp_host"
                id="smtp_port"
                :page="route.name"
            />
            <BaseInput
                class="col-12 mb-3"
                label="Porta SMTP"
                type="text"
                v-model="storeStores.store.meta.smtp_port"
                id="smtp_port"
                :page="route.name"
            />
            <BaseInput
                class="col-12 mb-3"
                label="Email SMTP"
                type="text"
                v-model="storeStores.store.meta.smtp_email"
                id="smtp_email"
                :page="route.name"
            />
            <BaseInput
                class="col-12 mb-3"
                label="Senha"
                type="password"
                v-model="storeStores.store.meta.smtp_password"
                id="password"
                :page="route.name"
            />
        </div>
    </div>
</template>

<script setup>
import { useStoreStore } from '@/stores/store';
import { useRoute } from 'vue-router';
const storeStores = useStoreStore();

const route = useRoute()
</script>